import React, { useEffect, useRef } from 'react';
import { Card, Button, Space } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import SegmentsResult from 'containers/Tools/CustomResults/SegmentsResult';
import { useSize } from 'ahooks';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import _ from 'lodash';

const DashboardContent = ({ content, globalFilter, dataSourceIds, setEditContentQuery, onSizeChange }) => {
  const ref = useRef();
  const size = useSize(ref);

  useEffect(() => {
    onSizeChange?.(content.id, size);
  }, [size]);

  return (
    <Card
      className="dashboard__content"
      ref={ref}
      title={(
        <Space>
          {content.title}
        </Space>
      )}
      extra={setEditContentQuery ? (
        <Space>
          <Button
            icon={<SettingOutlined />}
            onClick={() => {
              setEditContentQuery(content);
            }}
          >
            Settings
          </Button>
          <CopyToClipboardButton textToCopy={JSON.stringify({ title: content.title, resultsConfig: _.omit(content.resultsConfig, ['id', '__typename']) })} />
        </Space>
      ) : null}
    >
      <SegmentsResult resultConfig={content.resultsConfig} globalFilter={globalFilter} dataSourceIds={dataSourceIds} width={size?.width} />
    </Card>
  );
};

export default DashboardContent;
